module.exports = __webpack_public_path__ + "img/机器学习.98f08758.jpg";